// Homepage hero photo, shared by HomePage.tsx (the CSS background) and
// pages/home/+Head.tsx (the matching preloads). The URLs must be identical
// in both places or the browser fetches the image twice.
//
// Always served from the ellipsis CDN regardless of brand - both markets'
// assets live in the same bucket.

import { theme } from '../theme/theme';

export const heroFileForBrand = (brand: string): string =>
  brand === 'ellipsis' ? 'seychellesHero.jpg' : 'knysnaHero.jpg';

export const heroImageUrl = (brand: string, width: number): string =>
  `https://cdn.ellipsis.sc/${width}x0/filters:format(webp)/filters:quality(75)/assets/${heroFileForBrand(brand)}`;

// Rendered width per MUI breakpoint. `media` is derived from the theme's
// own (custom) breakpoint values, so the preload that matches is always the
// one the CSS picks - a mismatch would download the hero twice.
const mediaQuery = (query: string) => query.replace(/^@media\s*/, '');

export const heroImageSizes = [
  {
    breakpoint: 'xs',
    width: 800,
    media: mediaQuery(theme.breakpoints.down('md')),
  },
  {
    breakpoint: 'md',
    width: 1600,
    media: mediaQuery(theme.breakpoints.between('md', 'lg')),
  },
  {
    breakpoint: 'lg',
    width: 2400,
    media: mediaQuery(theme.breakpoints.up('lg')),
  },
] as const;
